/**
 * Prompt API Service
 *
 * Fetches fresh system prompt from the API.
 */

import { callAPI } from "../../../../api/client";
import { jsonToYaml } from "./yamlService";

interface SystemPromptResponse {
  prompts: Record<string, string>;
}

export class PromptApiService {
  async fetchFresh(): Promise<string> {
    const response = await callAPI("/system-prompts", null, "GET");

    if (!response.ok) {
      throw new Error(`API returned ${response.status}: ${response.statusText}`);
    }

    const responseText = await response.text();

    let data: SystemPromptResponse;
    try {
      data = JSON.parse(responseText);
    } catch (parseError) {
      throw new Error(`Invalid JSON response from API: ${parseError instanceof Error ? parseError.message : "Unknown error"}`);
    }

    return jsonToYaml(data.prompts);
  }
}

export const promptApiService = new PromptApiService();
